import React from 'react'

import { useGetAccountQuery } from 'store/account/accountApiWithQuery'

import { MenuGroup } from './MenuGroup'

export const MenuGroupAdmin = () => {
  const { data: account } = useGetAccountQuery()

  return (
    <MenuGroup
      key="admin"
      text={`ADMIN: ${
        account?.companies[0].id
          ? ` ${account?.companies[0].name} (C${account?.companies[0].id} A${account?.id})`
          : ' None'
      }`}
      url="/admin"
      code="admin"
      enabled
    />
  )
}
